import api from '@/api';

const { $core, $pricing, $payment } = api;

export const { $types } = $pricing;
export const { $applications } = $core;
export const { $conciliations } = $payment;
